<template>
    <div><!--库存设置-->
        <h3 style="margin-bottom: 10px">颜色：</h3>
        <template>
            <Tag type="border"
                 @click.native="selectThis(index)"
                 :color="isSelNum==index? 'primary':''"
                 style="margin:5px 10px"
                 v-for="(item, index) in colorsList"
                 :key="index">
                {{item.name}}
            </Tag>
        </template>
        <h3 style="margin: 30px 0">规格/库存：</h3>
        <div class="commoditymiss">
            <table>
                <tr>
                    <th>颜色</th>
                    <th>规格</th>
                    <th>库存</th>
                </tr>
                <tr>
                    <td>全部规格</td>
                    <td>规格</td>
                    <td>
                        <InputNumber :min="0" size="small" v-model="allStock" @on-change="selectDataAll"></InputNumber>
                    </td>
                </tr>
                <tr v-for="(item,index) in stockMerge[isSelNum].chilren" :key="index">
                    <td>{{item.color}}</td>
                    <td>{{item.name}}</td>
                    <td>
                        <InputNumber :min="0" size="small" v-model="item.moudel" @on-change="selectCount"></InputNumber>
                    </td>
                </tr>
            </table>
        </div>
        <h3 style="margin: 30px 0">供应商：</h3>
        <Form :label-width="100">
            <FormItem label="供应商：">
                <Row>
                    <Col span="14">
                        <Input v-model="$store.state.AddCommodity.SupplierName.name" disabled></Input>
                    </Col>
                    <Col span="3" offset="1">
                        <Button type="default" @click="selectSupplier">选择</Button>
                    </Col>
                </Row>
            </FormItem>
            <FormItem label="结算账户：">
                <Row>
                    <Col span="14">
                        <Select v-model="bankid">
                            <Option
                                    v-if="k.type!=6"
                                    :value="k.id"
                                    v-for="(k,v) in bankList"
                                    :key="v">{{k.bankname}}</Option>
                        </Select>
                    </Col>
                </Row>
            </FormItem>
            <FormItem label="实付金额：">
                <Row>
                    <Col span="14">
                        <Input type="number" v-model="paymoney" style="width: 205px"></Input>
                    </Col>
                    <Col span="3" >
                        <Button style="margin-left: 5px" @click="quanfu">{{normertexts}}</Button>
                    </Col>
                </Row>
            </FormItem>
        </Form>
        <Divider/>
        <Row>
            <Col span="12">
                <h3><span style="color: red;font-size: 26px">￥{{(this.$store.state.AddCommodity.allMoney).toFixed(2)}}</span> (共 {{this.$store.state.AddCommodity.count}} 件)</h3>
            </Col>
            <Col span="10" align="right">
                <Button type="warning" size="large" @click="selectOkSet()">确认</Button>
            </Col>
        </Row>

    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                cid: "",
                sid: '',
                isSelNum: 0,
                allStock: 0,
                resultNum: 0,
                //count: 0,//件数总和
               // allMoney: this.$store.state.AddCommodity.allMoney,
                cprice: this.$store.state.AddCommodity.cprice,
                bankList: [],
                bankname: '',
                bankid: '',
                paymoney: 0,//实付金额
                colorsList: this.$store.state.AddCommodity.colourGroup,
                sizeGroup: this.$store.state.AddCommodity.sizeGroup,
                stockMerge: [],
                normertexts:'未付'
            }
        },

        mounted: function () {
            //DOM更新完后再请求数据
            this.$nextTick(function () {
                // this.selectCount()
            });
        },
        watch: {
            'paymoney': {
                deep: true,
                handler: function (newVal,oldVal){
                     if(newVal>this.$store.state.AddCommodity.allMoney){
                         this.paymoney=this.$store.state.AddCommodity.allMoney
                     }
                }
            }
        },
        created: function () {
            //DOM更新完之前请求数据

            this.cid = JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.colorsList.forEach((item, index) => {
                     var array = []
                     var moudel=0
                     if(item.chilren==undefined){
                         moudel=0
                     }else {
                         moudel=0
                     }
                    this.sizeGroup.forEach((m, n) => {
                        array.push({
                            colorid: item.id,
                            sizeid: m.id,
                            color: item.name,
                            cid: m.cid,
                            classifyid: m.classifyid,
                            classifyname: m.classifyname,
                            id: m.id,
                            name: m.name,
                            sid: m.sid,
                            moudel:moudel
                        })
                    })
                    item.chilren = array
                    this.stockMerge.push(item)
            })
            this.selectCount()
            this.getBankList()
        },
        methods: {
            quanfu(){
                if(this.normertexts=='未付'){
                    this.normertexts='全付'
                    this.paymoney=this.$store.state.AddCommodity.allMoney
                }else{
                    this.normertexts='未付'
                     this.paymoney=0
                }
            },
            //获取银行卡
            getBankList() {
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if (res.code == 200) {
                        this.bankList = res.data
                        if (this.$store.state.AddCommodity.bank == '') {
                            this.bankid = res.data[0].id
                            this.$store.state.AddCommodity.bank = this.bankname
                            this.$store.state.AddCommodity.bankid = this.bankid
                        } else {
                           this.bankid = this.$store.state.AddCommodity.bankid
                            this.bankname = this.$store.state.AddCommodity.bank
                            //this.allMoney = this.$store.state.AddCommodity.money
                            this.paymoney = this.$store.state.AddCommodity.paymoney
                        }
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //选择color
            selectThis(n) {
                this.isSelNum = n
                this.allStock=0
            },
            //修改总数量
            selectDataAll(n) {
                if (n == this.resultNum + 1) {
                    this.stockMerge[this.isSelNum].chilren.forEach((item, index) => {
                        item.moudel++
                    })

                } else if (n + 1 == this.resultNum) {
                    this.stockMerge[this.isSelNum].chilren.forEach((item, index) => {
                        if(item.moudel<=0){
                            item.moudel=0
                        }else {
                            item.moudel--
                        }
                    })

                } else {
                    this.stockMerge[this.isSelNum].chilren.forEach((item, index) => {
                        if (n != item.moudel) {
                            item.moudel = n
                        }

                    })

                }

                this.resultNum = n
                //计算总件数
                this.$store.state.AddCommodity.count = 0
                this.stockMerge.forEach((item, index) => {
                    item.chilren.forEach((m, n) => {
                        this.$store.state.AddCommodity.count += m.moudel
                    })
                })

                this.$store.state.AddCommodity.allMoney = this.$store.state.AddCommodity.count  * this.$store.state.AddCommodity.cprice

            },
            //计算总件数
            selectCount() {
                this.$store.state.AddCommodity.count = 0
                this.stockMerge.forEach((item, index) => {
                    item.chilren.forEach((m, n) => {
                        this.$store.state.AddCommodity.count += m.moudel
                    })
                })

                this.$store.state.AddCommodity.allMoney = this.$store.state.AddCommodity.count * this.$store.state.AddCommodity.cprice

            },
            /***
             * 选择供应商
             * */
            selectSupplier() {
                this.$store.state.AddCommodity.childerDrawer = true
            },

            /***
             * selectOkSet确认按钮
             * */
            selectOkSet() {
                this.bankList.forEach((item, index) => {
                    if (item.id == this.bankid) {
                        this.bankname = item.bankname
                    }
                })
                this.$store.state.AddCommodity.bank = this.bankname
                this.$store.state.AddCommodity.bankid = this.bankid
                this.$store.state.AddCommodity.money = this.$store.state.AddCommodity.allMoney
                this.$store.state.AddCommodity.paymoney = this.paymoney
                this.$store.state.AddCommodity.goodsItems = this.stockMerge
                this.$store.state.AddCommodity.total = this.$store.state.AddCommodity.count
                this.$store.state.AddCommodity.allDrawer = false;
            }
        }
    }
</script>


<style lang="scss" scoped>
    .commoditymiss {
        table {
            width: 100%;
            text-align: center;

            tr {
                td {
                    padding-top: 10px;
                }

            }
        }
    }
</style>